<style lang="scss">
.how-to-section {
  .card-body {
    min-height: 250px;
  }

  .video-card {
    &.playing {
      .fa-play {
        display: none;
      }
    }
  }

  .fa-play {
    @include centerContent();
    top: calc(194px / 2);
    color: white;
    font-size: 40pt;
    text-shadow: 1px 1px 10px rgba(0,0,0,0.7);
  }
}

.dark-layout {
  .video-card {
    h5 {
      color: white !important;
    }
  }
}
</style>

<template>
  <div class="how-to-section row">
    <div class="col-12">
      <h3 class="mb-2">{{ title }}</h3>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-1" v-for="(video, index) in videos" :key="index">
      <div class="card video-card dark-mode-bg">
        <!--        <video-player-->
        <!--          class="video-player-box"-->
        <!--          ref="videoPlayer"-->
        <!--          :options="{width: '400',height: '225',language: 'en',playbackRates: [0.7, 1.0, 1.5, 2.0],sources: [{type: 'video/mp4',src: video.url}]}"-->
        <!--          :playsinline="true"-->
        <!--        />-->
        <video @click="play($event)" class="pointer" height="194" :src="video.url"></video>
        <i @click="play($event, true)" class="fa fa-play pointer"></i>
        <div class="card-body">
          <h5 class="card-title">{{ video.title }}</h5>
          <p class="card-text">{{ video.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    videos: Array
  },
  data() {
    return {
      test: ''
    }
  },
  mounted() {},
  methods: {
    play(e, btn) {
      document.querySelectorAll('.video-card').forEach(elm => {
        const video = elm.querySelector('video');
        video.removeAttribute('controls');
        elm.classList.remove('playing');
        video.pause();
      });

      const video = btn ? e.target.previousSibling : e.target;

      if (video) {
        video.setAttribute('controls', true);
        video.play();
        video.parentElement.classList.add('playing');
      }
    }
  }
}
</script>
